/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type MarketByAddressVariables = Types.Exact<{
  fullAddress: Types.Scalars['String']
}>

export type MarketByAddress = {
  __typename: 'Query'
  marketByAddress: {
    __typename: 'Market'
    id: number
    eventsReward: { __typename: 'Money'; formatted: string; cents: number }
    eventsMinOrdersAmount: {
      __typename: 'Money'
      cents: number
      formatted: string
    }
    eventsSalesGuaranteeAmount: {
      __typename: 'Money'
      cents: number
      formatted: string
    }
  } | null
}

export const MarketByAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketByAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fullAddress' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketByAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fullAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fullAddress' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventsReward' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formatted' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cents' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventsMinOrdersAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formatted' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventsSalesGuaranteeAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formatted' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode

/**
 * __useMarketByAddress__
 *
 * To run a query within a React component, call `useMarketByAddress` and pass it any options that fit your needs.
 * When your component renders, `useMarketByAddress` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketByAddress({
 *   variables: {
 *      fullAddress: // value for 'fullAddress'
 *   },
 * });
 */
export function useMarketByAddress(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MarketByAddress,
    MarketByAddressVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<MarketByAddress, MarketByAddressVariables>(
    MarketByAddressDocument,
    options
  )
}
export function useMarketByAddressLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MarketByAddress,
    MarketByAddressVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MarketByAddress,
    MarketByAddressVariables
  >(MarketByAddressDocument, options)
}
export type MarketByAddressHookResult = ReturnType<typeof useMarketByAddress>
export type MarketByAddressLazyQueryHookResult = ReturnType<
  typeof useMarketByAddressLazyQuery
>
export type MarketByAddressQueryResult = Apollo.QueryResult<
  MarketByAddress,
  MarketByAddressVariables
>
